import IIntegratorRunLog, {
  IntegratorRunStatus,
} from "../../../interfaces/models/IIntegratorRunLog";

export const STATUS_LABEL: Record<IntegratorRunStatus, string> = {
  queued: "Queued",
  "in-progress": "In progress",
  success: "Success",
  error: "Error",
  skipped: "Skipped",
};

export const STATUS_CLASS: Record<IntegratorRunStatus, string> = {
  queued: "bg-gray-100 text-gray-700",
  "in-progress": "bg-blue-100 text-blue-800",
  success: "bg-green-100 text-green-800",
  error: "bg-red-100 text-red-800",
  skipped: "bg-amber-100 text-amber-800",
};

export function triggerLabel(runLog: IIntegratorRunLog): string {
  const source = runLog.triggerSource === "scheduler" ? "Scheduler" : "Manual";
  return runLog.triggeredByName ? `${source} · ${runLog.triggeredByName}` : source;
}

export function statusLabel(status: IntegratorRunStatus): string {
  return STATUS_LABEL[status];
}

export function statusClassName(status: IntegratorRunStatus): string {
  return STATUS_CLASS[status];
}

const CLOSED_STATUSES = new Set<IntegratorRunStatus>([
  "success",
  "error",
  "skipped",
]);

export function isRunLogClosed(status: IntegratorRunStatus): boolean {
  return CLOSED_STATUSES.has(status);
}

export function formatStaffReviewDisplay(
  runLog: IIntegratorRunLog
): string | null {
  if (!runLog.staffReviewedDate) {
    return null;
  }
  const label = runLog.staffReviewedByLabel?.trim() || "WSG";
  const when = new Date(runLog.staffReviewedDate).toLocaleString("en-US");
  return `${label} · ${when}`;
}
